import React from 'react';
import { StyleSheet, Text, View } from './components/base_components';

const styles = StyleSheet.create({
  notFoundScreen: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'black',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: 'white',
    fontSize: '1.6rem',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  text: {
    color: 'white',
    fontSize: '1.6rem',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  spacer: {
    flex: 1,
  },
});

export default class NotFoundScreen extends React.PureComponent {
  render() {
    return (
      <View style={styles.notFoundScreen}>
        <View style={styles.spacer} />
        <Text style={styles.title}>Harbour NFT</Text>
        <View style={styles.spacer} />
        <Text style={styles.text}>Page Not Found</Text>
        <View style={styles.spacer} />
      </View>
    );
  }
}
